import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card } from 'antd';
import ComingSoonList from './coming-soon-list';
import RecentMovies from '../../components/recent-movies/recent-movies.component';
import _ from 'lodash';


class ComingSoonManageView extends Component {

  constructor(props) {
    super(props);

    this.state = {
    };

    this.handleRecentMovieItemClicked = this.handleRecentMovieItemClicked.bind(this);
  }

  handleRecentMovieItemClicked(e) {
    let movieId = _.get(e, 'id') || null;
    this.props.history.push('/coming-soon/add-movie/' + movieId);
  }

  render() {
    return (
      <div className="coming-soon-manage-view mx-auto" >
        <Card>
          <div className="container-fluid">
            <div className="row">
              <div className="coming-soon-list-area col-sm-9 col-12">
                <ComingSoonList />
              </div>
              <div className="recent-movies-area col-sm-3 col-12">
                <RecentMovies onItemClicked={this.handleRecentMovieItemClicked} />
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ComingSoonManageView));

